import { render, staticRenderFns } from "./SalesDynamicsCard.vue?vue&type=template&id=4154269c&scoped=true"
import script from "./SalesDynamicsCard.vue?vue&type=script&lang=js"
export * from "./SalesDynamicsCard.vue?vue&type=script&lang=js"
import style0 from "./SalesDynamicsCard.vue?vue&type=style&index=0&id=4154269c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4154269c",
  null
  
)

export default component.exports